<div class="loginFormWrapper"
     [class.media-handset]="layoutMatches.isHandsetDefaultLayout">
  <section
    class="login-form-section">
    <div class="progress-bar-spinner" [class.dark-grey-red-theme]="true">
      <mat-progress-bar style="margin: 0px; padding: 0px;" *ngIf="application.isActiveRequest" color="accent"
        mode="indeterminate"></mat-progress-bar>
    </div>
    <mat-card class="login-form-card">
      <img src="{{application.account.logo}}" class="login-logo" alt="Account Logo" />
      <section *ngIf="this.state=='default' || this.state=='success'">
        <form [formGroup]="resetForm" (ngSubmit)="onResetSubmit()">
          <h1 class="text-center">Reset password</h1><br />
          <mat-card style="padding: 0px; margin: 16px;" *ngIf="application.appError">
            <mat-toolbar color="warn">
              <mat-icon style="vertical-align: middle;">error</mat-icon>
              &nbsp;&nbsp;&nbsp;<span style="font-size: 14px;">{{application.appError}}</span>
            </mat-toolbar>
          </mat-card>
          <mat-card style="padding: 0px; margin: 16px;" *ngIf="resetStatus=='error'">
            <mat-toolbar color="warn">
              <mat-icon style="vertical-align: middle;">error</mat-icon>
              &nbsp;&nbsp;&nbsp;<span style="font-size: 14px;">Sorry, error occured. Please contact support.</span>
            </mat-toolbar>
          </mat-card>
          <mat-card style="padding: 0px; margin: 16px;" *ngIf="resetStatus=='invalid'">
            <mat-toolbar color="warn">
              <mat-icon style="vertical-align: middle;">error</mat-icon>
              &nbsp;&nbsp;&nbsp;<span style="font-size: 14px;">Sorry, this zero is invalid.</span>
            </mat-toolbar>
          </mat-card>
          <mat-card style="padding: 0px; margin: 16px;" *ngIf="resetStatus=='expired'">
            <mat-toolbar color="warn">
              <mat-icon style="vertical-align: middle;">error</mat-icon>
              &nbsp;&nbsp;&nbsp;<span style="font-size: 14px;">Sorry, this password reset zero has expired.</span>
            </mat-toolbar>
          </mat-card>

          <div class="errorContainer" *ngIf="resetMessage">
            <mat-icon class="loginErrorIcon" [class.extraErrorIconSpace]="resetMessage.length>45" color="warn">error</mat-icon>
            {{resetMessage}}
          </div>
          <!--<mat-card style="padding: 0px; margin: 16px;" *ngIf="resetMessage">-->
            <!--<section style="padding: 10px; margin-bottom: 20px;">-->
              <!--<mat-icon style="vertical-align: middle;" color="warn">error</mat-icon>-->
              <!--&nbsp;-->
              <!--<span style="font-size: 14px;">{{resetMessage}}</span>-->
            <!--</section>-->
          <!--</mat-card>-->

          <mat-card style="padding: 0px; margin: 16px;" *ngIf="state=='success'">
            <mat-toolbar color="accent">
              <mat-icon style="vertical-align: middle;">info</mat-icon>
              &nbsp;&nbsp;&nbsp;<span style="font-size: 14px;">Your password has been changed successfully.</span>
            </mat-toolbar>
          </mat-card>
          <section *ngIf="state=='default'">
            <div class="form-group">
              <mat-form-field appearance="outline" class="form-field" color="accent">
                <mat-label>New password</mat-label>
                <input matInput formControlName="password" type="password" value="">
                <mat-error class="form-error" *ngIf="this.resetFormErrors['password']">
                  {{this.resetFormErrors['password']}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-group">
              <mat-form-field appearance="outline" class="form-field" color="accent">
                <mat-label>Confirm password</mat-label>
                <input matInput formControlName="confirm_password" type="password" value="">
                <mat-error class="form-error" *ngIf="this.resetFormErrors['confirm_password']">
                  {{this.resetFormErrors['confirm_password']}}
                </mat-error>
              </mat-form-field>
            </div>
          </section>
          <div class="form-group">
            <mat-grid-list cols="2" rowHeight="4:1">
              <mat-grid-tile>
                <section class="leftLink" *ngIf="this.state!='success'">
                  <a class="quicklink font16" [routerLink]="['/login']" *ngIf="!this.accessLogins.length">
                    Back to Sign in
                  </a>
                  <a class="quicklink font16" (click)="this.state='accessreset_picklogin'" *ngIf="this.accessLogins.length > 1">
                    Back
                  </a>
                </section>
              </mat-grid-tile>
              <mat-grid-tile>
                <section style="width:100%; text-align: right;" *ngIf="this.state=='default'">
                  <button mat-raised-button color="accent" class="widerButton" style="padding: 0px 16px;">RESET PASSWORD</button>
                </section>
                <section style="width:100%; text-align: right;" *ngIf="this.state=='success'">
                  <a class="quicklink font16" [routerLink]="['/login']">
                    Back to Sign in
                  </a>
                </section>
              </mat-grid-tile>
            </mat-grid-list>
          </div>
        </form>
      </section>

      <section *ngIf="this.state=='expired'">
        <h1 class="text-center" style="margin-top: 40px">This zero has expired</h1>
        <section color="accent" style="padding: 10px; margin-top: 15px;">
          <span class="infoText">
              Your password reset zero has expired. Please click ‘Back to Sign In’ to reset your password again.
            </span>
        </section>
        <div class="form-group">
          <section style="width:100%; text-align: center; margin-top: 25px; margin-bottom: 15px;">
            <a class="quicklink font16" (click)="backToSignIn()">
              Back to Sign in
            </a>
          </section>
        </div>
      </section>

      <section *ngIf="this.state=='validating_error'">
        <h1 class="text-center" style="margin-top: 40px">Something get wrong!</h1>
        <section color="accent" style="padding: 10px; margin-top: 15px;">
          <span style="font-size: 16px;">
              Your password rest request couldn't be processed at this moment. Please try again later or start over again from sign in form.
            </span>
        </section>
        <div class="form-group">
          <section style="width:100%; text-align: center; margin-top: 25px; margin-bottom: 15px;">
            <a class="quicklink font16" (click)="backToSignIn()">
              Back to Sign in
            </a>
          </section>
        </div>
      </section>
      <!--<section *ngIf="this.state=='accessreset_sent'">-->
        <!--<h1 class="text-center" style="margin-top: 40px">Further steps to reset password</h1><br />-->
        <!--<section color="accent" style="padding: 10px;">-->
          <!--<mat-icon style="vertical-align: middle; line-height: 20px;" color="accent">info</mat-icon>-->
          <!--<span style="font-size: 16px;">-->
              <!--Please check your inbox to complete the recovery of your password. In case you did not receive the email,-->
              <!--please contact your account's administrator to check the validity of entered user name/email adress for-->
              <!--password reset.-->
            <!--</span>-->
        <!--</section>-->
        <!--<div class="form-group">-->
          <!--<section style="width:100%; text-align: center; margin-top: 25px;">-->
            <!--&lt;!&ndash;<button mat-raised-button color="accent" (click)="this.state='default'">Return to Sign-In</button>&ndash;&gt;-->
            <!--<a class="quicklink font16" (click)="this.state='default'">-->
              <!--Back to Sign in-->
            <!--</a>-->
          <!--</section>-->
        <!--</div>-->
      <!--</section>-->

      <!--<section *ngIf="this.state=='accessreset_notfound'">-->
        <!--<h1 class="text-center">Login or email not found</h1><br />-->
        <!--<mat-card style="padding: 0px; margin: 16px;" *ngIf="true">-->
          <!--<section color="accent" style="padding: 10px;">-->
            <!--<mat-icon style="vertical-align: middle;" color="warn">error</mat-icon>-->
            <!--&nbsp;-->
            <!--<span style="font-size: 14px;">-->
                <!--Sorry, login or email entered was not found. Please check and re-enter required credentials.-->
              <!--</span>-->
          <!--</section>-->
        <!--</mat-card>-->
        <!--<div class="form-group">-->
          <!--<mat-grid-list cols="2" rowHeight="4:1">-->
            <!--<mat-grid-tile>-->
              <!--<section style="width:100%; text-align: left;">-->
                <!--<button mat-button color="accent" (click)="this.state='default'"-->
                        <!--style="text-align: left; padding-left: 0px;">-->
                  <!--Cancel-->
                <!--</button>-->
              <!--</section>-->
            <!--</mat-grid-tile>-->
            <!--<mat-grid-tile>-->
              <!--<section style="width:100%; text-align: right;">-->
                <!--<button mat-raised-button color="accent" (click)="this.state='pwdreset'">Re-enter</button>-->
              <!--</section>-->
            <!--</mat-grid-tile>-->
          <!--</mat-grid-list>-->
        <!--</div>-->
      <!--</section>-->

      <section *ngIf="this.state=='accessreset_picklogin'">
        <form [formGroup]="pickLoginForm">
          <h1 class="text-center">Choose a user</h1>
          <section color="accent" style="padding: 0px; margin-top: 20px;">
            <div class="infoText" style="margin-left: 5px;">
              The password recovery email you entered is associated with several users.
              Please choose the user who needs to update his password.
            </div>
            <mat-radio-group matInput formControlName="recover_user" aria-labelledby="example-radio-group-label"
                             class="radio-group">
              <mat-radio-button class="radio-button" *ngFor="let login of accessLogins" [value]="login.login">
                <div
                  [matTooltip]="(login.name + login.login).length > 45 ? (login.name + login.login) : ''"
                  class="textCut">
                  {{login.name}} ({{login.login}})
                </div>
              </mat-radio-button>
            </mat-radio-group>
          </section>
          <div class="form-group">
            <mat-grid-list cols="2" rowHeight="4:1">
              <mat-grid-tile>
                <section class="leftLink" style="margin-left: 6px;">
                  <!--<button mat-button color="accent" [routerLink]="['/login']"-->
                          <!--style="text-align: left; padding-left: 0px;">-->
                    <!--Back to Sign-In-->
                  <!--</button>-->
                  <a class="quicklink font16" [routerLink]="['/login']">
                    Back to Sign in
                  </a>
                </section>
              </mat-grid-tile>
              <mat-grid-tile>
                <section style="width:100%; text-align: right; margin-right: 8px;">
                  <button mat-raised-button color="accent" class="widerButton" style="padding: 0px 16px;" (click)="pickedUserReset()">
                    RESET PASSWORD
                  </button>
                </section>
              </mat-grid-tile>
            </mat-grid-list>
          </div>
        </form>
      </section>
    </mat-card>
    <div class="backContainer contrast-text" *ngIf="application.account.back_link=='Y'">
      <a class="quicklink contrast-text" href="https://www.maytech.net/overview.html" target="_blank">
        Secure Data Transfer by Maytech
      </a>
    </div>
  </section>
</div>
